import { render, staticRenderFns } from "./UpdatePermission.vue?vue&type=template&id=718a9204&scoped=true&"
import script from "./UpdatePermission.vue?vue&type=script&lang=js&"
export * from "./UpdatePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718a9204",
  null
  
)

export default component.exports